<template>
    <div class="row center">
        <div class="col-12">
            <form action="https://sandbox.payfast.co.za/eng/process" method="POST" ref="form">
                <input type="hidden" name="merchant_id" :value="payfastButtonResponse.payfastObject.merchant_id">
                <input type="hidden" name="merchant_key" :value="payfastButtonResponse.payfastObject.merchant_key">
                <input type="hidden" name="return_url" :value="payfastButtonResponse.payfastObject.return_url">
                <input type="hidden" name="cancel_url" :value="payfastButtonResponse.payfastObject.cancel_url">
                <input type="hidden" name="notify_url" :value="payfastButtonResponse.payfastObject.notify_url">
                <input type="hidden" name="name_first" :value="payfastButtonResponse.payfastObject.name_first">
                <input type="hidden" name="name_last" :value="payfastButtonResponse.payfastObject.name_last">
                <input type="hidden" name="email_address" :value="payfastButtonResponse.payfastObject.email_address">
                <input type="hidden" name="m_payment_id" :value="payfastButtonResponse.payfastObject.m_payment_id">
                <input type="hidden" name="amount" :value="payfastButtonResponse.payfastObject.amount">
                <input type="hidden" name="item_name" :value="payfastButtonResponse.payfastObject.item_name">
                <input type="hidden" name="custom_str1" :value="payfastButtonResponse.payfastObject.custom_str1">
                <input type="hidden" name="email_confirmation" :value="payfastButtonResponse.payfastObject.email_confirmation">
                <input type="hidden" name="confirmation_address" :value="payfastButtonResponse.payfastObject.confirmation_address">
                <input type="hidden" name="signature" :value="payfastButtonResponse.signature">
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PayfastButton",
        props: {
            payfastButtonResponse: {
                required: true,
                type: Object
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.form.submit();
            });

        }

    }
</script>

<style scoped>
    .center {
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -50px;
        margin-left: -100px;
    }
</style>
